import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { connect } from 'react-redux';

import { Modal, Button, Spacer, Feedback } from '@ontruck/orc';
import {
  closeBreakModal,
  applyAndKeep,
  applyAndRelease,
} from 'redux/modules/shipper-order-edit/effects';

import { PENDING_ASSIGNMENT, ASSIGNED } from 'modules/shipper-order/Form/constants';

const t = {
  warning: {
    [PENDING_ASSIGNMENT]:
      'The job will be broken if the changes are applied. TMS will decide what to do with the orders.',
    [ASSIGNED]: 'The assigned vehicle may not be able to do the job if the changes are confirmed.',
  },
  apply_keep: 'Apply changes and keep same driver',
  apply_release: 'Apply changes and release order',
  cancel: 'Cancel changes',
};

class BreakModal extends Component {
  render() {
    const { closeBreakModal, values, applyAndKeep, applyAndRelease, mode } = this.props;

    return (
      <Modal
        show={true}
        size={'S'}
        closeButton={false}
        headerComponent={null}
        onClose={closeBreakModal}
      >
        <Spacer mBottom="S">
          {!!t.warning[mode] && (
            <Feedback size="wideS" skin="warning">
              {t.warning[mode]}
            </Feedback>
          )}
        </Spacer>
        {mode === ASSIGNED && (
          <Spacer mBottom="XS">
            <Button fullWidth onClick={() => applyAndKeep(values)}>
              {t.apply_keep}
            </Button>
          </Spacer>
        )}
        <Spacer mBottom="XS">
          <Button fullWidth onClick={() => applyAndRelease(values)}>
            {t.apply_release}
          </Button>
        </Spacer>
        <Button nude skin="secondary" fullWidth onClick={closeBreakModal}>
          {t.cancel}
        </Button>
      </Modal>
    );
  }
}

BreakModal.propTypes = {
  closeBreakModal: PropTypes.func.isRequired,
  applyAndKeep: PropTypes.func,
  applyAndRelease: PropTypes.func,
  values: PropTypes.object.isRequired,
  mode: PropTypes.oneOf([ASSIGNED, PENDING_ASSIGNMENT]).isRequired,
};

BreakModal.defaultProps = {
  applyAndKeep: () => {
    /*noop*/
  },
  applyAndRelease: () => {
    /*noop*/
  },
};

const actionCreators = {
  closeBreakModal,
  applyAndKeep,
  applyAndRelease,
};

export default connect(null, actionCreators)(BreakModal);
